import {Component, Input} from '@angular/core';

@Component({
  selector: 'greydom-hint',
  templateUrl: './greydom-hint.component.html',
  styleUrls: []
})
export class GreydomHintComponent {
  @Input() hint: string = 'Hint: click on a row to expand more information';
  @Input() customCssClasses: Array<string> = ['mat-primary-color font-small'];

}